module.exports = __webpack_public_path__ + "img/9.4fd4d39b.png";